// extracted by mini-css-extract-plugin
module.exports = {"slideContainer":"styles_slideContainer__3TCcV","filler":"styles_filler__1o28-","backbtn":"styles_backbtn__bIYnJ"};